import './App.css';
import Footer from './components/Footer';
import Contact from './components/Contact';
import Projects from'./components/Projects';
import About from'./components/About';
import Hero from './components/Hero';
import Navbar from'./components/Navbar';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Hero/>
      <About/>
      <Projects/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
